<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-form ref="form" v-bind="this.$attrs">
        <v-row>
          <v-col cols="12" md="8">
            <GradeClassStudentSelect
              :gradeCol="{ cols: 12, md: 6 }"
              :classCol="{ cols: 12, md: 6 }"
              disableStudentSelect
              @changed="gradeClassChange"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4" v-if="!canFilterByTeacher">
            <AutocompleteSubjectGroup
              clear-icon="mdi-close"
              label="Bộ môn"
              dense
              hide-details
              outlined
              @change="subjectGroupChanged"
            />
          </v-col>
          <v-col cols="12" md="4">
            <AutocompleteSubject
              v-model="subject"
              clear-icon="mdi-close"
              label="Môn học"
              outlined
              dense
              :filter="subjectFilter"
              hide-details
            />
          </v-col>
          <v-col cols="12" md="4" v-if="!canFilterByTeacher">
            <AutocompleteTeacherCard
              v-model="teacher"
              item-text="name"
              clear-icon="mdi-close"
              label="Giáo viên phụ trách"
              outlined
              dense
              deletable-chips
              hide-details
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-select
              v-model="status"
              :items="teachingPlanStatuses"
              clear-icon="mdi-close"
              item-text="title"
              item-value="value"
              label="Trạng thái"
              outlined
              dense
              clearable
              hide-details
            /> </v-col
        ></v-row>
      </v-form>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined> Tìm kiếm </v-btn>
    </div>
  </div>
</template>

<script>
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
import AutocompleteSubjectGroup from '@/components/basic/input/AutocompleteSubjectGroup'
import AutocompleteSubject from '@/components/basic/input/AutocompleteSubject'
import AutocompleteTeacherCard from '@/components/basic/input/AutocompleteTeacherCard'
import { mapGetters, mapState } from 'vuex'
import { get } from 'lodash'
export default {
  components: {
    GradeClassStudentSelect,
    AutocompleteSubjectGroup,
    AutocompleteSubject,
    AutocompleteTeacherCard,
  },
  data: () => ({
    selectedGrade: {},
    selectedClass: {},
    status: '',
    subject: '',
    subjectGroup: '',
    teacher: null,
  }),
  computed: {
    ...mapGetters('constant', ['teachingPlanStatuses']),
    ...mapState('subjects', ['subjects']),
    subjectFilter() {
      return { subjectGroup: this.subjectGroup, grade: get(this.selectedGrade, 'id') }
    },
    canFilterByTeacher() {
      return get(this.$auth.user, 'role.type') === 'teacher'
    },
  },
  methods: {
    gradeClassChange(data) {
      if (get(this.selectedGrade, 'academicLevel') !== get(data.grade, 'academicLevel')) {
        this.selectedClass = {}
        this.subjectGroup = ''
        this.subject = ''
      }
      this.selectedGrade = { ...data.grade }
      this.selectedClass = { ...data.class }
    },
    onFilterChanged() {
      if (!this.$refs.form.validate()) return
      const params = {
        status: this.status,
        teacher: get(this.$auth.user, 'role.type') === 'teacher' ? this.$auth.user.teacher : get(this.teacher, 'id'),
        grade: get(this.selectedGrade, 'id'),
        class: get(this.selectedClass, 'id'),
        subject: this.subject || undefined,
        subjectGroup: this.subjectGroup || undefined,
      }
      this.$emit('onFilterChanged', params)
    },
    subjectGroupChanged(subjectGroup) {
      if (subjectGroup && subjectGroup !== this.subjectGroup) {
        this.subject = ''
      }
      this.subjectGroup = subjectGroup
    },
  },
  created() {},
  mounted() {
    this.onFilterChanged()
  },
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
